import apiClient from "./axiosConfig";

// Get purchases list with search or batch_id
export const getPurchasesList = async (params = {}) => {
  try {
    const { search = '', batch_id = '', page = 1, page_size = 10 } = params;
    const queryParams = new URLSearchParams();
    
    if (search) queryParams.append('search', search);
    if (batch_id) queryParams.append('batch_id', batch_id);
    if (page) queryParams.append('page', page);
    if (page_size) queryParams.append('page_size', page_size);
    
    const response = await apiClient.get(`/stock-management/purchases/?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching purchases:', error);
    throw error;
  }
};

// Get purchase detail
export const getPurchaseDetail = async (purchaseId) => {
  try {
    const response = await apiClient.get(`/stock-management/purchases/${purchaseId}/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching purchase detail:', error);
    throw error;
  }
};

// Create new purchase
export const createPurchase = async (purchaseData) => {
  try {
    const payload = {
      product: parseInt(purchaseData.product_id),
      batch: parseInt(purchaseData.batch_id),
      quantity: parseInt(purchaseData.quantity),
      selling_price: parseFloat(purchaseData.selling_price),
      buying_price: parseFloat(purchaseData.buying_price),
      record_point: parseInt(purchaseData.record_point || 10),
      available_qty: parseInt(purchaseData.available_qty)
    };
    
    // Include unique_id if it exists
    if (purchaseData.unique_id && purchaseData.unique_id.trim() !== '') {
      payload.unique_id = purchaseData.unique_id;
    }
    
    // Validate required fields
    if (!payload.product || isNaN(payload.product)) {
      throw new Error('Invalid product ID. Please select a valid product.');
    }
    if (!payload.batch || isNaN(payload.batch)) {
      throw new Error('Invalid batch ID.');
    }
    
    const response = await apiClient.post('/stock-management/purchases/', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating purchase:', error);
    console.error('Error response:', error.response?.data);
    console.error('Full error details:', JSON.stringify(error.response?.data, null, 2));
    throw error;
  }
};

// Update purchase
export const updatePurchase = async (purchaseId, purchaseData) => {
  try {
    const payload = {};
    
    // Only include selling_price if provided
    if (purchaseData.selling_price !== undefined || purchaseData.sellingPrice !== undefined) {
      payload.selling_price = parseFloat(purchaseData.selling_price || purchaseData.sellingPrice);
    }
    
    // Only include buying_price if provided
    if (purchaseData.buying_price !== undefined || purchaseData.buyingPrice !== undefined) {
      payload.buying_price = parseFloat(purchaseData.buying_price || purchaseData.buyingPrice);
    }
    
    if (purchaseData.unique_id && purchaseData.unique_id.trim() !== '') {
      payload.unique_id = purchaseData.unique_id.trim();
    }
    
    const response = await apiClient.patch(`/stock-management/purchases/${purchaseId}/`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating purchase:', error);
    throw error;
  }
};

// Delete purchase
export const deletePurchase = async (purchaseId) => {
  try {
    const response = await apiClient.delete(`/stock-management/purchases/${purchaseId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting purchase:', error);
    throw error;
  }
};